import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer, { history } from './redux/reducer/index';
import { Login, Header, Loginuserid } from '../src/containers/pagelistAsync';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import ZErrorBoundary from '../src/components/errorBoundary/ZErrorBoundary'
import { ConnectedRouter, routerMiddleware } from 'connected-react-router/immutable';
import './App.css';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { Toaster } from 'react-hot-toast';
import packageJson from '../package.json';
import ZCookiePopup from '../src/components/dialog/ZCookiePopup';
import {HardwareDetail} from '../src/containers/pagelistAsync'
import  ZButton from '../src/components/button/ZButton'
import Label from './utils/constants/ConstantEng';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ZTypography from '../src/components/typography/ZTypography';
import ZHeader from '../src/components/header/ZHeader'
const loginType = window.globalConfig.loginType
global.appVersion = packageJson.version;
const version = window.globalConfig.version;

const enhancers = [applyMiddleware(routerMiddleware(history), thunk)];
const composeEnhancers = process.env.NODE_ENV !== 'production'
  && typeof window === 'object'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    shouldHotReload: false
  })
  : compose;

const store = createStore(
  reducer,
  composeEnhancers(...enhancers)
)

const checkVersionMismatch = (letest, current) => {

  const letestVersion = letest.split(/\./g);

  const currentVersion = current.split(/\./g);

  while (letestVersion.length || currentVersion.length) {

    const a = Number(letestVersion.shift());

    const b = Number(currentVersion.shift());

    // eslint-disable-next-line no-continue

    if (a === b) continue;

    // eslint-disable-next-line no-restricted-globals

    return a > b || isNaN(b);

  }

  return false;

};

function Container(props) {
  const [isCookieOpen, setIsCookieOpen] = useState(false)
  //const [isUpdated, setIsUpdated] = useState(true)
  useEffect(() => {
    // fetch('/meta.json')
    //   .then((response) => response.json())
    //   .then((meta) => {
    const currentVersion = localStorage.getItem('version');

    const latestVersion = version || "0.0.000";

    if (currentVersion) {
      const shouldForceRefresh = checkVersionMismatch(latestVersion, currentVersion);

      if (shouldForceRefresh) {
        localStorage.removeItem("version");
        console.log(`New verion - ${latestVersion}`);
        if (caches) {
          caches.keys().then((names) => {
            // console.log("caches", names)
            for (const name of names) {
              caches.delete(name);
            }
          });
        }
      } else {
        console.log(`Already latest version - ${latestVersion}. No refresh required.`);
      }
    }
    localStorage.setItem('version', latestVersion);

    var cookies = localStorage.getItem('cookies');

    if (cookies) {
      setIsCookieOpen(false)
    } else {
      setIsCookieOpen(true)
    }

  }, [])

  const cookieClose = () => {
    setIsCookieOpen(false)
    localStorage.setItem('cookies', "true");
  }

  const laterClick = () => {
      document.getElementById("new-updates").style.display = "none"
  }
    
  const refreshPage = () => {
     document.getElementById("new-updates").style.display = "none"
     window.location.reload(true)
  }
    useEffect(() => {
      
      window.addEventListener('focus', () => {
      navigator.serviceWorker.getRegistrations()
      .then(registrationsArray => {
       if (registrationsArray.length != 0) {
          registrationsArray[0].update();
        }
       })
    })
    window.addEventListener("click", () => {
        navigator.serviceWorker.getRegistrations()
        .then(registrationsArray => {
          if (registrationsArray.length != 0) {
             registrationsArray[0].update();
           }
         })
    })
  }, [])

    useEffect(() => {
          return () => {
            
              window.removeEventListener('focus', () => {
                 navigator.serviceWorker.getRegistrations()
                  .then(registrationsArray => {
                  if (registrationsArray.length != 0) {
                    registrationsArray[0].update();
                  }
              })
           })
           window.removeEventListener('click', () => {
              navigator.serviceWorker.getRegistrations()
              .then(registrationsArray => {
              if (registrationsArray.length != 0) {
                  registrationsArray[0].update();
               }
             })
        }) }
        }
    , [])

return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <ZErrorBoundary>
            <div id="new-updates" style={{ position: 'fixed',
                                            left: 20,
                                            bottom: 20,
                                            zIndex: 3000,
                                            background: '#fff',
                                            maxWidth: 400,
                                            borderRadius: 10,
                                            boxShadow: 'rgba(0, 0, 0, 14%) 5px 5px 18px 5px',}}>
                <DialogContent style={{ padding: 5, paddingLeft: 10 }}>
            
                     <ZTypography style={{fontWeight:'bold'}}>A new version of TrakZo is available </ZTypography>
                
                    <ZTypography>Click on 'Update Now' to get the Latest version</ZTypography>
                </DialogContent>
                <DialogActions >
                <ZButton variant="outlined" onClick={laterClick } color="primary" name="Later"></ZButton>
               
                    <ZButton variant="contained" onClick={refreshPage} color="primary" name="Update Now"></ZButton>
                </DialogActions>
            </div>
              <Toaster position="bottom-center" reverseOrder={false}
                toastOptions={{
                  id: "trakzo_toaster",
                  duration: 5000,
                  success: {
                    style: {
                      boxShadow: 'rgba(10,187,135, 0.15) 0px 6px 12px -2px, rgba(255, 255, 255, 0.3) 0px 6px 12px -2px',
                      border: '1px solid #0ABB87'
                    }
                  },
                  error: {
                    style: {
                      boxShadow: 'rgba(253,57,122, 0.15) 0px 6px 12px -2px, rgba(255, 255, 255, 0.3) 0px 6px 12px -2px',
                      border: '1px solid #fd397a'
                    }
                  }
                }}
              />
              <Switch>
                {loginType == "AD" ? <Route path="/" exact component={Loginuserid} /> : <Route path="/" exact component={Login} />}


                {/* <Route path="/userverification/:id" component={Login} /> */}
                {/* <Route path={Label.path.hardwareDetails} component={HardwareDetail} /> */}
                <Route path="/" component={Header} />

              </Switch>
            </ZErrorBoundary>
          </ConnectedRouter>
          {isCookieOpen &&
            < ZCookiePopup
              open={isCookieOpen}
              handleClose={() => cookieClose()}></ZCookiePopup>
          }
        </Provider>

      </ThemeProvider>
    </BrowserRouter >
  )

}


const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#1084B4",
      light: "#00AFEF",
      grey: "#F5F6F9"
    },

    secondary: {
      contrastText: "#fff",
      dark: "#FF9567",
      light: "#FF9567",
      main: "#FF9567"
    },
    text: {
      primary: "#000000",
      secondary: "#9B9B9B",
      chartTitle: "#616161",
      placeholder: "#B1B1B1",
    },


    productiveApp: "#5ED771",

    border: {
      primary: "rgba(0,0,0,0.1)"
    },

    info: {
      main: "#46b3f3",
      light: "#8bc7f7",
      secondary: "#F4F6FC"
    },

    list: {
      active: "rgb(140 158 255 / 26%)",
      selected: "rgba(16, 132, 180, 0.08)",
      secondary: "#9B9B9B"
    },
    errorText: {
      main: "#FF0000"
    },
    checked: {
      checkedColor: "#30CF35",
      unChecked: "#C4C4C4",
    },

  },
  typography: {
    // body1: {
    //   fontSize: 22,
    // },

    // body2: {
    //   fontSize: 20,
    // },

    fontFamily: [
      // 'GothicRegular',
      // 'GothicBold',
      // 'GothicBoldItalic',
      // 'GothicItalic'
      'GT Walsheim Pro'
    ].join(','),
  },
  overrides: {
    MuiButton: {
      contained: {
        color: "#fff",
        backgroundColor: "#00AFEF",
        '&:hover': {
          backgroundColor: "#00AFEF",
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: "#00AFEF",
          },
        }
      }
    }
  }
});


export default (Container);